import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, Text, LoadingBackdrop } from '@olxbr/design-system'

import CheckCircleSymbol from '../../atoms/CheckCircleSymbol'
import AlertSymbol from '../../atoms/AlertSymbol'
import Subtitle from '../../atoms/Subtitle'
import Lurker from '../../../util/lurker'
import { ajuda, deactivateAccount } from '../../../config/staticUrl'
import { confirm } from '../../../api/accountDeactivationApiCall'
import Link from '../../atoms/Link'

const lurker = new Lurker('account_deactivation_confirmation')

const ContentWrapper = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 128px;
`

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin-left: 64px;
`

const TitleWrapper = styled(View)`
  margin-top: 0;
  margin-bottom: 16px;
`

const SymbolWrapper = styled(View)`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const SubtitleWrapper = styled(View)`
  margin-top: 16px;
`

const LinkWrapper = styled(Link)`
  font-size: 16px !important;
  font-weight: 400;
`

class AccountDeactivationConfirmationTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      status: 'loading',
    }
  }

  componentDidMount() {
    lurker.pageLoadEvt()
    this.confirmInactivation()
  }

  confirmInactivation = () => {
    this.setState({ status: 'loading' })
    const { token } = this.props
    confirm(token)
      .then(() => {
        lurker.viewMessageEvt('success')
        this.setState({ status: 'success' })
      })
      .catch((error = {}) => {
        const { response: { status } = {} } = error
        if (status === 410) {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'invalid_token',
            accounts_status_code: status,
          })
          this.setState({ status: 'invalid_token' })
        } else if (status) {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'unexpected_status_code',
            accounts_status_code: status,
          })
          this.setState({ status: 'error' })
        } else {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'unexpected_error',
            accounts_error_message: (error && error.message) || 'unknown',
          })
          this.setState({ status: 'error' })
        }
      })
  }

  render() {
    const { status } = this.state

    if (status === 'loading') {
      return <LoadingBackdrop />
    }

    if (status === 'success') {
      return (
        <ContentWrapper>
          <SymbolWrapper>
            <CheckCircleSymbol width={64} height={64} />
          </SymbolWrapper>
          <Content>
            <TitleWrapper>
              <Text size="title2" weight="bold">
                Em breve sua conta será desativada
              </Text>
            </TitleWrapper>
            <Text>Obrigado por usar a OLX. Esperamos vê-lo em breve!</Text>
            <Text>- Time OLX</Text>
          </Content>
        </ContentWrapper>
      )
    }

    return (
      <ContentWrapper>
        <SymbolWrapper>
          <AlertSymbol width={64} height={64} />
        </SymbolWrapper>
        <Content>
          <TitleWrapper>
            <Text size="title2" weight="bold">
              Link expirado
            </Text>
          </TitleWrapper>
          <SubtitleWrapper>
            <Subtitle>O link para inativação de conta não é válido ou já foi usado.</Subtitle>
          </SubtitleWrapper>
          <SubtitleWrapper>
            <Text color="grayscale.darker">
              Precisa da{' '}
              <LinkWrapper type="primary" href={ajuda}>
                nossa ajuda
              </LinkWrapper>
              ? Ou ainda gostaria de{' '}
              <LinkWrapper type="primary" href={deactivateAccount}>
                inativar sua conta?
              </LinkWrapper>
            </Text>
          </SubtitleWrapper>
        </Content>
      </ContentWrapper>
    )
  }
}

AccountDeactivationConfirmationTemplate.propTypes = {
  token: PropTypes.string,
}

export default AccountDeactivationConfirmationTemplate
